var scope_0 = require('/opt/build/repo/packages/gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/46d8a886f7cb32a45a363759a9923008.js').default;
var scope_1 = require('/opt/build/repo/packages/gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_2 = require('/opt/build/repo/packages/gatsby/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e9b32b5d488d102bd98d4c53e0fbd7a9.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    